import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_INNSYN_BY_EMAIL_URL = (email) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/innsyn/pr_email/${email}`;
